module.exports = __webpack_public_path__ + "assets/3b3dfc94de27d026d2e5e38898b56d55.mp4";